import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'app/hooks';
import { AdminStateProps } from 'features/admin/adminSlice';
import { RootState } from '../app/store';

export const useAdmin = (): AdminStateProps =>
  useAppSelector((state: RootState) => state.admin, shallowEqual);
